/* global backUrl refreshCommitmentDataUrl ticketingCommitmentStoreUrl uncommittedTicketingsCancelUrl */
/* global suppliersIndexUrl suppliersStoreUrl suppliersCreateUrl getRevenueMilestonesUrl */
/* global minDate maxDate listUsersUrl currentUserId ticketingValueTotals */

import { React, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import TicketingCommitForm from './TicketingCommitForm';

import { idempotencyHeader } from 'Helpers/apiUtils';

import { UsersProvider } from 'Context/UsersContext';

export default function TicketingCommit() {
    // One idempotency key per mounted screen, so a double-clicked commit (or a retried
    // request) can never create two commitments for the same intent.
    const [mutationHeader] = useState(idempotencyHeader());

    return (
        <TicketingCommitForm
            backUrl={backUrl}
            refreshCommitmentDataUrl={refreshCommitmentDataUrl}
            storeUrl={ticketingCommitmentStoreUrl}
            cancelUrl={uncommittedTicketingsCancelUrl}
            mutationHeader={mutationHeader}
            suppliersIndexUrl={suppliersIndexUrl}
            suppliersStoreUrl={suppliersStoreUrl}
            suppliersCreateUrl={suppliersCreateUrl}
            getRevenueMilestonesUrl={getRevenueMilestonesUrl}
            minDate={minDate}
            maxDate={maxDate}
            listUsersUrl={listUsersUrl}
            currentUserId={currentUserId}
            valueTotals={ticketingValueTotals}
        />
    );
}

if (document.getElementById('TicketingCommit')) {
    var root = document.getElementById('TicketingCommit');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={listUsersUrl}>
                <TicketingCommit />
            </UsersProvider>
        </App>,
        root,
    );
}
